import { SUPPORTED_LANGUAGES } from './constants';

import type { SupportedLanguage } from './globalTypes';

export function isSupportedLanguage(value: string): value is SupportedLanguage {
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

/** @returns the browser's preferred language */
export function getBrowserLanguage(): SupportedLanguage {
  if (typeof navigator !== 'undefined' && navigator.language) {
    const preferred = navigator.language.split('-')[0];
    if (isSupportedLanguage(preferred)) {
      return preferred;
    }
  }

  return process.env.NEXT_PUBLIC_DEFAULT_LANG as SupportedLanguage;
}
